import React from 'react'

import { SlidersHorizontal } from 'lucide-react'
import { DropdownMenuItem } from 'twyne-new.ui'

import { ConfigureButton, HeaderSeparator, ReportDatePicker, ReportHeader, ReportHeaderDates, ReportHeaderDesktopActions, ReportHeaderMobileActions, ReportMobileMenu, RunButton } from '@/components/reports/header'

const ReportsFailureHeader = ({ onClickFilter, onChangeDates, dates, sync, isLoading }) => <>
  <ReportHeader title='Failure Report'>
    <ReportHeaderDates>
      <ReportDatePicker dates={dates} onChange={onChangeDates} />
    </ReportHeaderDates>
    <HeaderSeparator />
    <ReportHeaderDesktopActions>
      <ConfigureButton onClick={onClickFilter} />
    </ReportHeaderDesktopActions>
    <ReportHeaderMobileActions>
      <ReportMobileMenu>
        <DropdownMenuItem icon={SlidersHorizontal} onSelect={onClickFilter}>Configure</DropdownMenuItem>
      </ReportMobileMenu>
      <RunButton onClick={sync} isLoading={isLoading} disabled={isLoading} />
    </ReportHeaderMobileActions>
  </ReportHeader>
</>

export default ReportsFailureHeader
